
@import 'src/styles/common/_colors.scss';
.shortname {
    padding: 0 5px;
    margin: 1px 
}
.shortname-div-gray {
    background-color: $lightgray;
    border: 1px solid $radio-button-background-9;
    color: $black;
    cursor: pointer;
}

.shortname-div-green {
    background-color:$green;
    color: $white;
    border: 1px solid $green;
    cursor: default;
}

.shortname-div-red {
    background-color: $red;
    color: $white;
    border: 1px solid $red;
    cursor: pointer;
}

.offeringPopover {
    background-color: $mightnight-black;
    color: $white;
    min-width: 370px !important;
    max-width: 370px !important;
    border: 1px solid $smoke-white;
    top: 36px;
    font-size: 12px;
    left: -15px !important;
    z-index: 9999;
    position:fixed !important;

    .popoverHeader {
        background-color: $mightnight-black;
        white-space: normal;
        color: $white;
        font-size: 12px !important;
        padding: 20px 20px 0px 20px;
        white-space: normal;

        .closeIcon {
            position: absolute;
            right: 0px;
            font-size: 9px !important;
            color: $white;
            cursor: pointer;
            top: 10px;
        }

        .headerTitle {
            border-bottom: 1px solid $lightgray;
            padding-bottom: 5px;
        }
    }

    .popoverBody {
        padding: 5px 20px 20px;
        color: $white;
        div {
            padding-top: 5px;
        }
    }
    .expired {
        color: $light-red !important;
    }
}